/**
 * @voltxampere/ui — Diode (Diyot)
 *
 * Triangle pointing right (anode → cathode forward direction) with
 * a vertical bar at the cathode side. Anode lead enters at x=0,
 * cathode exits at x=40.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { STROKE_IVORY, STROKE_WIDTH_MAIN, VIEWBOX_DEFAULT } from "./constants.js";
export const diode = {
    id: "diode",
    nameTr: "Diyot",
    nameEn: "Diode",
    shortcut: "D",
    category: "active",
    viewBox: VIEWBOX_DEFAULT,
    terminals: [
        { x: 0, y: 13, label: "A", polarity: "in" },
        { x: 40, y: 13, label: "K", polarity: "out" },
    ],
    defaultLabel: "D",
    renderSVG: () => [
        `<line x1="0" y1="13" x2="13" y2="13" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<polygon points="13,6 24,13 13,20" fill="none" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="24" y1="6" x2="24" y2="20" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="24" y1="13" x2="40" y2="13" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
    ].join(""),
};
//# sourceMappingURL=diode.js.map